import React from "react"
import Form from "react-bootstrap/Form"
import UsefetchCollection from "../Componentslogic/Usefetchcollection"
import CreateproductHook from "../Componentslogic/productsLogic/CreateproductHook"
import CreatecategoryHook from "../Componentslogic/categoriesLogic/CreatecategoryHook"
import "../../Styles/Addproduct.css"
import { motion as m } from "framer-motion"

const Addproduct = () => {
  const { data: categories } = UsefetchCollection("Categories")
  const [Catname, , , handleCategorySubmit, handleCategoryChange] =
    CreatecategoryHook()
  const [
    name,
    description,
    priceBefore,
    ,
    handleProductSubmit,
    handleNameChange,
    handleDescriptionChange,
    handleCategoryIdChange,
    handlePriceChange,
    ,
    catId,
    catName,
  ] = CreateproductHook()

  return (
    <m.div
      initial={{ opacity: 0, x: 15 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.5, delay: 0.3 }}
      className="add-product-container"
    >
      {/* Add Category Section */}
      <div className="add-category-section">
        <form className="category-form">
          <h2 className="section-title">Add Category</h2>
          <input
            onChange={handleCategoryChange}
            value={Catname}
            className="form-input"
            placeholder="Add category name"
            type="text"
          />
          <button
            onClick={(e) => handleCategorySubmit(e)}
            className="btns-Admin"
          >
            Add Category
          </button>
        </form>
      </div>

      {/* Add Product Section */}
      <div className="add-product-section">
        <h2 className="section-title">Add Product</h2>
        <form className="product-form">
          <input
            onChange={handleNameChange}
            value={name}
            className="form-input"
            placeholder="Add Product name"
            type="text"
          />
          <textarea
            onChange={handleDescriptionChange}
            value={description}
            className="form-textarea"
            placeholder="Add Product description"
            rows="3"
          />
          <Form.Select
            onChange={handleCategoryIdChange}
            value={catId ? `${catId}|${catName}` : ""}
            className="form-input"
          >
            <option value="">Select category please</option>
            {categories?.map((category, index) => (
              <option key={index} value={`${category.id}|${category.name}`}>
                {category.name}
              </option>
            ))}
          </Form.Select>
          <input
            onChange={handlePriceChange}
            value={priceBefore}
            className="form-input"
            placeholder="Add Product Price"
            type="number"
          />
          <button onClick={handleProductSubmit} className="btns-Admin">
            Add Product
          </button>
        </form>
      </div>
    </m.div>
  )
}

export default Addproduct
